module.exports = __webpack_public_path__ + "img/lighting.3807b10b.png";